// Credits : https://codepen.io/aaronkahlhamer/pen/GveaXP

import BigPicture from "bigpicture";
import Swiper from "swiper";
import { Pagination } from "swiper/modules";

class DepartureGallery {
	mySwiper = null;
	breakpoint = window.matchMedia("(min-width:768px)");

	constructor(mainContainerClass, imagesContainerClass) {
		this.mainContainerClass = mainContainerClass;

		this.mainContainer = document.querySelector(
			`.${this.mainContainerClass}`
		);
		this.imagesContainer = document.querySelectorAll(
			`.${imagesContainerClass}`
		);


	}

	init() {
		this.breakpoint.addEventListener("change", () => {
			this.init();
		});

		if (!this.mainContainer) {
			return;
		}

		// if larger viewport and multi-row layout needed
		if (this.breakpoint.matches === true) {
			// clean up old instances and inline styles when available
			if (this.mySwiper !== undefined) this.mySwiper?.destroy(true, true);

			if (!this.imagesContainer) {
				return;
			}

			this.enableLightView();

			// else if a small viewport and single column layout needed
		} else if (this.breakpoint.matches === false) {
			this.disableLightView();
			// fire small viewport version of swiper
			this.enableSwiper();
		}
	}

	enableLightView() {
		this.mainContainer?.classList.remove("layoutGallery--swiper");
		this.mainContainer?.classList.add("layoutGallery--lightview");

		this.imagesContainer.forEach((image) => {
			image.addEventListener("click", (e) => {
				this.lightViewInstance(e);
			});
		});



		//on click btn
		const btnOpenGallery = this.mainContainer.querySelector(
			".layoutGallery__btn"
		);
		if (btnOpenGallery) {
			btnOpenGallery.addEventListener("click", (e) => {
							this.lightViewInstance(e);

			});
		}
	}

	disableLightView() {
		this.mainContainer?.classList.remove("layoutGallery--lightview");

		this.imagesContainer.forEach((image) => {
			image.removeEventListener("click", (e) => {
				this.lightViewInstance(e);
			});
		});
	}

	lightViewInstance(e) {

		return BigPicture({
			el: e.target,
			gallery: `.${this.mainContainerClass}`,
		});
	}

	enableSwiper() {
		this.mainContainer?.classList.add("layoutGallery--swiper");

		this.mySwiper = new Swiper(this.mainContainer, {
			modules: [Pagination],
			loop: true,
			slidesPerView: 1,
			spaceBetween: 0,
			grabCursor: true,
			centeredSlides: true,
			pagination: {
				el: ".layoutGallery__pagination",
				type: "fraction",
			},
		});
	}
}

export default DepartureGallery;
